/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './deleteRecord.defs.js'
export * as $defs from './deleteRecord.defs.js'
